export const statusBadgeClass = status => {
  if (['fix_available', 'resolved'].includes(status)) {
    return 'bg-n-teal-3 text-n-teal-12 border-n-teal-6';
  }
  if (status === 'awaiting_information') {
    return 'bg-n-amber-3 text-n-amber-11 border-n-amber-6';
  }
  if (['reviewing', 'planned', 'in_progress'].includes(status)) {
    return 'bg-n-blue-3 text-n-blue-11 border-n-blue-6';
  }
  return 'bg-n-slate-3 text-n-slate-11 border-n-slate-6';
};
